import './text-area.scss'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

const TextArea = ({
  value,
  label,
  onChange,
  name,
  isLocked,
  onUnlock,
  placeholder,
  disabled,
}) => {
  const inputPlaceholder = isLocked ? 'mixed' : placeholder
  const inputDisabled = isLocked ? true : disabled
  const inputValue = value === null ? '' : value
  return (
    <div className="text-area">
      <label for={name}>{label}</label>
      <div className="relative">
        <textarea
          value={inputValue}
          onChange={onChange}
          name={name}
          id={name}
          disabled={inputDisabled}
          placeholder={inputPlaceholder}
        />
        {isLocked && (
          <div className="absolute h-full top-0 right-4 flex items-center justify-center ">
            <button
              className="bg-gray-light b-0 border-0 h-[37px] w-[35px] flex items-center justify-center rounded"
              onClick={onUnlock}
            >
              <EditIcon height="20" width="20" fill="#ccc" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default TextArea
